module.exports = __webpack_public_path__ + "img/profile-login.504902f8.svg";